import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAvatarUrl, getArtistName } from '../selectors/header'
import { getArtistCountry, getArtistId } from '../selectors/app'
import { getSelectedFacetsCount } from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  avatarUrl: getAvatarUrl,
  artistName: getArtistName,
  artistCountry: getArtistCountry,
  artistId: getArtistId,
  facetsCount: getSelectedFacetsCount,
})

export type ConnectorProps = {
  avatarUrl: string
  artistName: string
  artistCountry: string
  artistId: number
  facetsCount: number
}
export default connect(mapStateToProps)
